(function() {
  var prenotazioniModal = new window.Modals('ModalPrenotazioni', 'prenotazioni-modal');
  //ModalPrenotazioni.open();


  let $container = $(".product-actions");
  let $feedBack = $("#form-feedback")
  let $buy = $("#buy_as_is");
  let $submit = $(".product-form__cart-submit");

  $buy.on('click', function(ev){
    ev.preventDefault();    
    $submit.removeAttr('disabled');
    $container.addClass('disabled');
  });


  $.urlParam = function (name) {
      var results = new RegExp('[\?&]' + name + '=([^&#]*)')
                        .exec(window.location.search);

      return (results !== null) ? results[1] || 0 : false;
  }

  function showSuccess() {
    $submit.removeAttr('disabled');
    $container.addClass('disabled');

    $feedBack.show();
  }

  //se torno dalla challenge
  if ($.urlParam('contact_posted') == 'true') {
    showSuccess();
  }


  function ajaxForms_contact(contact_forms){
    
    
    // Loop forms and add event listener
    $.each(contact_forms, function(i, form) {
        var formData = {
            form: $(this),
            formId: $(this).attr('id'),
            action: $(this).attr('action'),
            successMsg: "<p class='note note--success'>Thanks for contacting us. We'll get back to you as soon as possible.</p>"
        };
        
        // Add submit event listener
        $(formData.form).on('submit', function (e) {
            // Init AJAX
            $.ajax({
                type: 'POST',
                async: true,
                url: formData.action,
                data: formData.form.serialize(),
                beforeSend: function() {
                    formData.form.addClass('sending'); 
                },
                error: function(data) {
                    console.log('error: ',data);
                    formData.form.addClass('error');
                    
                    // 429 error - too many requests
                    if(data.status == 429) {
                        // Allow for default redirect to challenge form, do not force
                        console.log('Allow default window redirection for challenge');
                    }else {
                        e.preventDefault(); // if fields are empty, paste errors 
                        $(formData.form).before("<div class='errors'>" + response.statusText + "</div>");
                    }
                },
                success: function (data) {
                    e.preventDefault(); // prevent default if successful and challenge is not needed
                    console.log('success: ',data);
                    formData.form.addClass('success');
                    formData.form.fadeOut(300, function(){
                        formData.form.closest('div').append(formData.successMsg);
                    });

                    showSuccess();
                }
            }); // close ajax
        }); // close 'submit' event
    }); // close loop
}

// Init function
ajaxForms_contact($('.contact-form'));
  

})();
